import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { WithApp } from 'contexts/appContext';
import { wsGetAll, wsFindBy } from 'services/WService';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import moment from 'moment';
import MultiComplete from 'components/Tvendo/Common/MultiComplete';

export default WithApp(function ModalCuotaProvider(props) {
  const cuota = props.model;
  const customerPortfolioB = props.model;
  const {grupos_incentivos} = props;
  const [incentivoData, setIncentivoData] = useState([]);
  // const incentivos = props.incentivos;

  const [dataImport, setDataImport] = useState({});
  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);

  const [zonas, setZones] = useState([]);
  const [mesas, setMesas] = useState([]);
  const [canal, setCanal] = useState([]);
  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
  }

  async function listMesas() {
    let response = await wsFindBy('base/bureau', {base_zone_id: dataChanging.base_zone_id, state: 'A', delete_at: null});
    if (response.success) setMesas(response.data);
  }
  async function listCanales() {
    let response = await wsGetAll('sale/canal-incentivo');
    if (response.success) setCanal(response.data);
  }  
  function handleChange(field, value) {
    setDataChanging(prev => ({...prev,[field]: value,}));
  }

  useEffect(() => {
    if (customerPortfolioB.open) {
      if (!customerPortfolioB.id) listZones();listCanales();
      setDataChanging(customerPortfolioB);
    }
  }, [customerPortfolioB.open]);

  useEffect(() => {
    if (cuota.open) setBPartnerSelect(undefined);
  }, [cuota.open]);


  useEffect(() => {
    if (props.grupos_incentivos) {
      setIncentivoData([props.grupos_incentivos]);
      setDataChanging(prev => ({
        ...prev,
        unilever_grupo_id: props.grupos_incentivos.id,
      }));
    }
  }, [props.grupos_incentivos]);



  useEffect(() => {
    if (dataChanging.base_zone_id) {
      setMesas([]);
      listMesas();
    }
  }, [dataChanging.base_zone_id]);

  return (
    <>
      <Modal
        title={`Nueva distribucion de grupo de incentivo`}
        model={{ open: cuota.open }}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        grupos_incentivos={props.grupos_incentivos}
        arrDataResponse
        entity='sale/grupo-incentivo-canal'
        dataForce={{
          unilever_grupo_id: grupos_incentivos.id,
          base_zone_id: dataChanging.base_zone_id,
          base_bureau_id: dataChanging.base_bureau_id,
        }}
      >
        <Autocomplete
          disableClearable
          options={zonas}
          required
          getOptionLabel={(item) => `${item.description}`}
          renderInput={(params) => (
            <TextField {...params} label="Zona" margin="normal" fullWidth />
          )}
          onChange={(e, item) => {handleChange('base_zone_id', item?.id); setDataImport(null);}}
          value={zonas.find((zona) => zona.id === dataChanging.base_zone_id) || null}
          style={{ flexGrow: 1, marginRight: '10px' }}
        />
        <Autocomplete
          disableClearable
          options={mesas}
          getOptionLabel={(item) => `${item.description}`}
          renderInput={(params) => (
            <TextField {...params} label="Mesa" margin="normal" fullWidth />
          )}
          onChange={(e, item) => {handleChange('base_bureau_id', item?.id); setDataImport(null);}}
          value={mesas.find((mesa) => mesa.id === dataChanging.base_bureau_id) || null}
          style={{ flexGrow: 1, marginRight: '10px' }}
        />
        <FormControl fullWidth margin="normal" size="small">
          <InputLabel>Canal</InputLabel>
          <Select
            required
            value={dataChanging.base_canal_id || ''}
            inputProps={{
              name: 'base_canal_id',
              onChange: (e) => handleChange('base_canal_id', e.target.value),
            }}
          >
            {canal.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.description}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          label="Incentivo vendedor"
          fullWidth
          type="number"
          name="incentivo_vendedor"
          margin="normal"
          value={dataChanging.incentivo_vendedor || ''}
          onChange={(e) => handleChange('incentivo_vendedor', e.target.value)}
          required
        />
        <TextField
          label="Incentivo supervisor"
          fullWidth
          type="number"
          name="incentivo_supervisor"
          margin="normal"
          value={dataChanging.incentivo_supervisor || ''}
          onChange={(e) => handleChange('incentivo_supervisor', e.target.value)}
          required
        />
      </Modal>
    </>
  );
});
